<template>
	<MStateBox :loading="initialLoading" :empty="isEmpty" class="act-container">
		<CScrollPro ref="scrollRef" pullDown @pull-down="onPullDown" pullUp :moreData="hasMoreData" @pull-up="onPullUp">
			<div class="act-content">
				<CCardSymbol
					v-for="(item, index) in finalData"
					:key="index"
					:isShowCoverPicture="false"
					:item="item"
					:formatter="
						() => ({
							subject: item.title,
							imageUrl: isResearch(item) ? '' : item.logo43,
							date: formatActivityDate(item)
						})
					"
					@click="viewInvestmentActivityDetail(item)"
				></CCardSymbol>
			</div>
		</CScrollPro>
	</MStateBox>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import CScrollPro from '@/view/enterprise/components/c-scroll-pro.vue';
import CCardSymbol from '@/view/enterprise/components/c-card-symbol.vue';
import { formatIrYear, dateFormat } from '@/utils/api';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { usePaginationMobile } from '@rebuild/hooks/load-more/usePaginationMobile';
import { useCurrentReactive } from '@rebuild/materials/shared/investment_activity/context';

const { investment_activity } = useModuleData();

const isResearch = data => data.businessTypes === 3;
const formatActivityDate = item => {
	if (isResearch(item)) return dateFormat(new Date(Number(item.date)), 'yyyy-MM-dd');
	return formatIrYear(item.date);
};

const { viewInvestmentActivity } = useCurrentReactive();
const viewInvestmentActivityDetail = item => {
	viewInvestmentActivity(item);
};

const loadData = async () => {
	await investment_activity.refresh({
		pagestart: currentPage.value - 1,
		pagenum: pageSize.value
	});

	// 使用统一的 setData 接口（自动判断重置/追加）
	const data = investment_activity.data;
	const newData = data?.rows || [];
	const total = data?.total || 0;
	setData(newData, total);
};

const {
	currentPage,
	pageSize,

	finalData,
	setData,
	hasMoreData,
	onPullDown,
	onPullUp
} = usePaginationMobile({
	bindChange: loadData
});

// 首屏加载
const initialLoading = ref(true);
const isEmpty = computed(() => !initialLoading.value && finalData.value.length === 0);

onMounted(async () => {
	await loadData();
	initialLoading.value = false;
});
</script>

<style lang="less" scoped>
.act-container {
	height: 100%;
	background: #fff;
	padding: 0 0.12rem;
}
.act-content {
	padding-top: 0.12rem;
}
</style>
